import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { CommonLibService } from '@lib/services';
import {
  GetDocumentListTktStore,
  resetGetDocumentListTkt,
  selectGetDocumentListTktIsFailureStatus,
  selectGetDocumentListTktState,
  setGetDocumentListTktFromApi,
} from '@common/store';
import { Store, select } from '@ngrx/store';
import { DefaultService as Api } from 'src/sdk-servicing/api/default.service';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom, zipWith } from 'rxjs/operators';
import { GetDocumentListTktRequest, GetDocumentListTktResponse } from 'src/sdk-servicing';

/**
 * S05-P011_領収書選択 航空券リスト取得APIとレスポンス管理ストアを操作するためのサービス
 *
 */
@Injectable()
export class GetDocumentListTktStoreService extends ServicingBaseClass {
  private result$!: Observable<GetDocumentListTktResponse | null>;
  private failure$!: Observable<boolean>;

  public get res$() {
    return this.result$;
  }

  constructor(private store: Store<GetDocumentListTktStore>, private api: Api, private common: CommonLibService) {
    super();
    this.result$ = this.store.pipe(
      select(selectGetDocumentListTktState),
      map((state) => state.model)
    );
    this.failure$ = this.store.pipe(
      select(selectGetDocumentListTktIsFailureStatus),
      filter((isFailure) => isFailure)
    );
  }

  setupHandler<T>(
    responseHandler: (response: GetDocumentListTktResponse, responseWith: T) => void,
    errorHandler: (apiErrorCode?: string) => void,
    observableWith: Observable<T>
  ) {
    this.subscribeService(this.result$.pipe(filter(Boolean), zipWith(observableWith)), (result) => {
      responseHandler(result[0], result[1]);
    });
    this.subscribeService(
      this.failure$.pipe(
        withLatestFrom(this.common.apiErrorResponseService.getApiErrorResponse$(), (_, state) => state)
      ),
      (model) => {
        const errors = model?.errors;
        const apiErrorCode = errors && errors.length ? errors[0].code : undefined;

        errorHandler(apiErrorCode);
      }
    );
  }

  callApi(req: GetDocumentListTktRequest) {
    const call = this.api.ordersGetDocumentListTktPost(req);
    this.store.dispatch(setGetDocumentListTktFromApi({ call }));
  }
  /**
   * ストアを空にします。
   */
  clearStore(): void {
    this.store.dispatch(resetGetDocumentListTkt());
  }

  override destroy(): void {}
}
